import gql from 'graphql-tag';

export default gql`
  query ($student: MongoID) {
    progresss(limit: 10000, filter: { student: $student }) {
      _id
      progress
      zoomprogress
      certificateProgress
      student {
        _id
      }
      content {
        _id
        name
      }
      path
    }
  }
`;
